import padding from "@src/presentation/design-tokens/padding";
import styled from "styled-components";

export const Wrapper = styled.div`
  .btn {
    font-size: 1rem;
    padding: ${padding.p2} ${padding.p4};
  }
`;
